var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellEmpty = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 10c0-3.06-2.29-5.585-5.25-5.954V2h-1.5v2.046A6.001 6.001 0 0 0 6 10v7.5H4V19h16v-1.5h-2zm-1.5 7.5V10a4.5 4.5 0 1 0-9 0v7.5zM12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2",
    clipRule: "evenodd"
  })));
};
export default SvgBellEmpty;